<template>
  <v-card
    class="jns-cotacoes-card"
    :id="'card-' + item.id"
    :style="getCotacoesCardStyle()"
    elevation="0"
    @click="$emit('card-clicked', item)"
  >
    <v-card-title>
      <v-flex xs6>
        <v-chip>Nº {{ item.id_apolice || item.id }}</v-chip>
      </v-flex>

      <v-flex xs6 class="pull-right">
        <strong class="value mr-1 pt-2" v-if="item.importancia_segurada">
          {{
            item.importancia_segurada.toLocaleString(
              "pt-BR",
              $settings.moneyFormatOptions
            )
          }}
        </strong>
      </v-flex>
    </v-card-title>

    <v-card-text>
      <p>Tomador:</p>
      <p>
        <strong class="value">{{ item.tomador.nome }}</strong>
      </p>
      <p>Segurado:</p>
      <p>
        <strong class="value">{{ item.segurado.nome }}</strong>
      </p>
      <p>Modalidade:</p>
      <p>
        <strong class="value">{{ item.produto.nome }}</strong>
      </p>
    </v-card-text>
    <v-card-actions>
      <i class="material-icons value">access_time</i>
      <p class="value">{{ actionRightText }}</p>
      <v-spacer></v-spacer>
      <v-chip
        :color="
          !['RECUSADA', 'CANCELADA'].includes(status.toUpperCase()) ? color : ''
        "
        :style="getStatusStyle()"
        >{{ status }}</v-chip
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="js">
export default {
  name: "CotacoesCard",
  computed: {
    status: function () {
      return this.item.status.replace("Seguradora", "").replace("Corretor", "");
    },
  },
  methods: {
    getCotacoesCardStyle() {
      let style = [];
      let t = this;
      style.push({ borderBottom: ".3vh solid" + t.color });
      if (t.removeBorderLeft) {
        style.push({ borderLeft: "none" });
      }
      if (t.removeBorderRight) {
        style.push({ borderRight: "none" });
      }
      return style;
    },

    getStatusStyle() {
      if (this.item.fase == "ANALISE") return [{ color: "white" }];
    },
  },
  props: [
    "item",
    "color",
    "removeBorderLeft",
    "removeBorderRight",
    "actionRightText",
    "produto",
  ],
};
</script>

<style lang="scss" scoped>
.jns-cotacoes-card.v-card {
  box-shadow: none;
  margin: 5px;
  position: static;
  border-top: none;
  border-radius: 4px;
  cursor: pointer;

  .v-card__text {
    font-size: 1.5vh !important;
    padding: 1.8vh !important;
  }

  .span {
    font-weight: bold !important;
    font-size: 1.8vh !important;
  }

  .v-card__title {
    padding-bottom: 0vh !important;
    font-size: 1.8vh !important;
  }

  .v-card__actions {
    padding-left: 12px;
    padding-right: 12px;
    border-top: 0.1vh solid #9797979e;
    font-size: 1.5vh;
    font-weight: bold;
    margin: 0;
    color: #000;

    i {
      font-size: 1.5vh;
      margin-right: 1vh;
      font-weight: bold;
    }

    span {
      margin: 0;
    }
  }
  .kanban-actions {
    cursor: pointer;
  }
  .card__text {
    padding: 12px;
    padding-bottom: 0;
  }
  img {
    margin-top: 60px;
    margin-bottom: 20px;
    height: 32px;
  }
  p {
    margin-bottom: 0;
    padding-bottom: 0;
    color: #979797;
  }
  h3 {
    color: #4e4e4e;
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  span {
    font-size: 1.5vh;
    font-weight: 700;
    line-height: 18px;
  }

  .span-status {
    display: flow-root;
  }

  .spacer {
    margin: 0;
  }
  .value {
    color: #585858;
  }
  .shadow-text {
    margin-top: -30px;
    display: none;
    margin-left: 12px;
    position: absolute;
    color: white;
    i {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/CotacoesCard.vue